import React from 'react';

const Icon123OrientationUSofaBumperSectionalRight = props => (
  <svg
    focusable="false"
    viewBox="0 0 1025 800"
    aria-hidden="true"
    role="presentation"
    {...props}
  >
    <g>
      <path
        d="M98.7,80.07h202.25v216.75H84.2V94.57c0-8,6.5-14.5,14.5-14.5Z"
        transform="translate(381.02 -4.13) rotate(90)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M31.95,38.08v41.99s0,216.75,0,216.75h52.25s0-216.75,0-216.75h206.49c5.66,0,10.26-4.59,10.26-10.26v-31.73c0-5.66-4.59-10.26-10.26-10.26H42.21c-5.66,0-10.26,4.59-10.26,10.26Z"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <g>
        <polygon
          points="84.2 296.82 84.2 730.32 300.95 730.32 300.95 513.57 300.95 296.82 84.2 296.82"
          fill="transparent"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="10"
        />
        <path
          d="M154.7,616.75h32.67v259.82c0,5.07-4.11,9.18-9.18,9.18h-23.49c-5.07,0-9.18-4.11-9.18-9.18v-250.64c0-5.07,4.11-9.18,9.18-9.18Z"
          transform="translate(-584.8 917.7) rotate(-90)"
          fill="transparent"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="10"
        />
        <path
          d="M31.95,296.82v424.5c0,4.97,4.03,9,9,9h43.25v-433.5H31.95Z"
          fill="transparent"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="10"
        />
      </g>
      <line
        x1="84.2"
        y1="296.82"
        x2="300.95"
        y2="296.82"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
    </g>
    <g>
      <polygon
        points="300.95 80.07 300.95 296.82 517.7 296.82 734.45 296.82 734.45 80.07 300.95 80.07"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M725.45,27.83h-415.5c-4.97,0-9,4.03-9,9v43.25h433.5v-43.25c0-4.97-4.03-9-9-9Z"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <g>
        <path
          d="M960.37,27.83h23.67c4.97,0,9,4.03,9,9v259.99h-32.67c-5.07,0-9.18-4.11-9.18-9.18V37.01c0-5.07,4.11-9.18,9.18-9.18Z"
          transform="translate(1944.24 324.65) rotate(-180)"
          fill="transparent"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="10"
        />
        <path
          d="M734.45,27.83h216.75v43.25c0,4.97-4.03,9-9,9h-198.75c-4.97,0-9-4.03-9-9V27.83h0Z"
          transform="translate(1685.64 107.9) rotate(-180)"
          fill="transparent"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="10"
        />
        <path
          d="M951.2,287.82V80.07h-216.75v281.11h258.6v-64.36h-32.85c-4.97,0-9-4.03-9-9Z"
          fill="transparent"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="10"
        />
      </g>
    </g>
  </svg>
);

export default Icon123OrientationUSofaBumperSectionalRight;
